module.exports = __webpack_public_path__ + "media/images/new_landing/logos/vodafone-d9a7deb76d22af8c0d091915e0da70c1.png";